var path = '/var/www/mmscny-cms/src/app/common/app-nav/app-nav-footer.html';
var html = "<footer class=\"navbar-fixed-bottom text-center\"> <div class=footer> <p>&copy; {{$ctrl.currentYear}} Rural Health Network of SCNY. All Rights Reserved</p> </div> </footer>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/app-nav/app-nav-footer.html
// module id = 705
// module chunks = 0